import React from "react";
import Modal from 'react-awesome-modal';
import {observer} from "mobx-react";
import {autoPopOptionsModal} from "../../control"
import 'react-toastify/dist/ReactToastify.css';
import {DropDownList} from "@progress/kendo-react-dropdowns";
import ibsStore from "../Stores/IbsSurveyStore";
import {allAssetClasses, clearDictionary} from "../../ibsHelper";
import {previewMorningStarData, saveOptionsModal} from "../../Services/IBS/IbsService";

const AddOptionRowModal = observer((props) => {
    const closeModal = () => {
        ibsStore.showOptionRowModal = false;
        ibsStore.editOptionModal = false;
        clearDictionary(ibsStore.tempOptionsRowInfo)
    }

    const addAndCloseModal = async () => {
        //create option row in DC and find way to keep rowID
        //let test = insertEmptyRowCtrl("Options")
        await saveOptionsModal(ibsStore.tempOptionsRowInfo.ProviderName, ibsStore.tempOptionsRowInfo.OptionName, ibsStore.tempOptionsRowInfo.MorningStarId, ibsStore.tempOptionsRowInfo.AssetCategoryID, ibsStore.tempOptionsRowInfo.MandateStyleID, ibsStore.tempOptionsRowInfo.OptionID, ibsStore.tempOptionsRowInfo.Ticker, ibsStore.tempOptionsRowInfo.ShareClass, ibsStore.tempOptionsRowInfo.UseSecLend)
        closeModal()
        //technically lastRowAdded should work...
        //send saves for 4 fields

        //call rest of prepopulate, for other columns!
        //autoPopOptionRow(ibsStore.tempOptionsRowInfo.OptionID)
    }

    const saveAndCloseModal = async () => {
        //send saves for 4 fields
        //saveInputValueDC("ProviderName", ibsStore.tempOptionsRowInfo.ProviderName, "Options", ibsStore.tempOptionsRowInfo.OptionID)
        //saveInputValueDC("OptionName", ibsStore.tempOptionsRowInfo.OptionName, "Options", ibsStore.tempOptionsRowInfo.OptionID)
        //saveInputValueDC("AssetClassID", ibsStore.tempOptionsRowInfo.AssetCategoryID, "Options", ibsStore.tempOptionsRowInfo.OptionID)
        //saveInputValueDC("StyleID", ibsStore.tempOptionsRowInfo.MandateStyleID, "Options", ibsStore.tempOptionsRowInfo.OptionID)
        await saveOptionsModal(ibsStore.tempOptionsRowInfo.ProviderName, ibsStore.tempOptionsRowInfo.OptionName, ibsStore.tempOptionsRowInfo.MorningStarId, ibsStore.tempOptionsRowInfo.AssetCategoryID, ibsStore.tempOptionsRowInfo.MandateStyleID, ibsStore.tempOptionsRowInfo.OptionID, ibsStore.tempOptionsRowInfo.Ticker, ibsStore.tempOptionsRowInfo.ShareClass, ibsStore.tempOptionsRowInfo.UseSecLend)
        closeModal()
        //getTableData("Options")

        //call rest of prepopulate, for other columns!
    }

    const findMorningStarData = () => {
        previewMorningStarData(ibsStore.tempOptionsRowInfo.MorningStarId);
    }

    const maxLengthCheck = (name, e, maxLen) => {
        if (e.target.value.length > maxLen) {
            alert(name + ' must be ' + maxLen + ' or less. Extra characters will be removed' );

            ibsStore.tempOptionsRowInfo[name] = e.target.value.substring(0, maxLen);
        }
    }

    let assetCategoryData = allAssetClasses()

    const onChange = (name, e) => {
        ibsStore.tempOptionsRowInfo[name] = e.target.value
    };
    const onChangeAssetCat = (e) => {
        let assetClass = e.target.value
        let assetId = ibsStore.allTableResponses["AssetClassCategoriesMap"][assetClass];
        ibsStore.tempOptionsRowInfo.AssetCategoryID = assetId
        ibsStore.tempOptionsRowInfo.AssetCategoryName = assetClass
        ibsStore.legalStyles = Array.from(ibsStore.allTableResponses["MappingAM"][assetId], (obj) => { return obj.StyleName; });
        ibsStore.tempOptionsRowInfo.MandateStyleID = null
        ibsStore.tempOptionsRowInfo.MandateStyleName = ""

    }
    const onChangeUseSecLend = (e) => {
        const chosen = e.target.value;
        if (chosen === "Yes") {
            ibsStore.tempOptionsRowInfo.UseSecLend = true;
        } else if (chosen === "No") {
            ibsStore.tempOptionsRowInfo.UseSecLend = false;
        } else {
            ibsStore.tempOptionsRowInfo.UseSecLend = null;
        }
    }

    const getUseSecLendValueForDropDown = () => {
        const raw = ibsStore.tempOptionsRowInfo.UseSecLend;
        if (raw === null || raw === undefined || raw === "" || raw === "null") return "";
        if (raw === true || raw === 1 || raw === "1") return "Yes";
        if (raw === false || raw === 0 || raw === "0") return "No";
        return "";
    }

    const onChangeMandateStyle = (e) => {
        let styleName = e.target.value
        //let styleId = ibsStore.legalStyles.find(({ name }) =>  === styleName);
        //might not be supported in IE11
        //let styleID = Object.keys(ibsStore.legalStyles).find(key => ibsStore.legalStyles[key] === styleName);
        let assetID = ibsStore.tempOptionsRowInfo.AssetCategoryID
        let styleIndex = Object.keys(ibsStore.allTableResponses["MappingAM"][assetID]).find(key => ibsStore.allTableResponses["MappingAM"][assetID][key].StyleName === styleName);
        let styleID = ibsStore.allTableResponses["MappingAM"][assetID][styleIndex].StyleID
        ibsStore.tempOptionsRowInfo.MandateStyleID = styleID
        ibsStore.tempOptionsRowInfo.MandateStyleName = ibsStore.allTableResponses["MappingAM"][assetID][styleIndex].StyleName

    }

    const onBlur = (name, e) => {
        //if provider or option, call prepop and then set Asset ID and mandate StyleID, preload styles accordingly too
        //console.log(ibsStore.tempOptionsRowInfo.ProviderName, ibsStore.tempOptionsRowInfo.OptionName)
        if (ibsStore.tempOptionsRowInfo.ProviderName != "" && ibsStore.tempOptionsRowInfo.OptionName != "") autoPopOptionsModal()
    };
    const allFieldsNotFilled = () => {
        //console.log(ibsStore.tempOptionsRowInfo)
        if (ibsStore.tempOptionsRowInfo.ProviderName && ibsStore.tempOptionsRowInfo.AssetCategoryID && ibsStore.tempOptionsRowInfo.OptionName && (ibsStore.tempOptionsRowInfo.MandateStyleID || ibsStore.legalStyles.length == 0)) {
            return false
        }
        return true
    }
    //              onClickAway={}
    return (
        <React.Fragment>
            <section>

                <Modal
                    visible={ibsStore.showOptionRowModal}
                    width="600"
                    height="auto"
                    effect="fadeInDown"
                    onClickAway={closeModal}
                >
                    <div style={{ display: 'flex' }} className="optionRowModalDiv">
                        <div className="subaccountModal">
                            <h3> <i className="fa fa-edit"></i> {ibsStore.editOptionModal ? "Edit option" : "Add option"}</h3>
                            <hr />
                            <div className="row">
                                <div className="col-md-4">
                                    <span className="comment-heading">Morningstar Id: </span>  &nbsp;  <br />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="textInput def-textbox  wideInput" onBlur={findMorningStarData} onChange={(e) => onChange('MorningStarId', e)} value={ibsStore.tempOptionsRowInfo.MorningStarId}></input>
                                </div>

                                <p className="textError">{ibsStore.tempOptionsRowInfo.Message}</p>
                            </div>
                            <hr />

                            <div className="row">

                                <div className="col-md-4">

                                    <span className="comment-heading">Provider name: </span>  &nbsp;  <br />


                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="textInput def-textbox  wideInput" name={"ProviderName"} onBlur={(e) => onBlur('ProviderName', e)} onChange={(e) => onChange('ProviderName', e)} value={ibsStore.tempOptionsRowInfo.ProviderName}></input>

                                </div>



                            </div>
                            <div className="row">
                                <div className="col-md-4">

                                    <span className="comment-heading">Option name: </span>  &nbsp;  <br />


                                </div>
                                <div className="col-md-4">
                                    <input type="text" onChange={(e) => onChange('OptionName', e)} className="textInput def-textbox wideInput" onBlur={(e) => onBlur('OptionName', e)} value={ibsStore.tempOptionsRowInfo.OptionName}></input>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">

                                    <span className="comment-heading ">Asset category:</span>  &nbsp;  <br />


                                </div>
                                <div className="col-md-4">
                                    <DropDownList className="wideInput surveySelect" data={assetCategoryData} onChange={onChangeAssetCat} value={ibsStore.tempOptionsRowInfo.AssetCategoryName}></DropDownList>

                                </div>

                            </div>
                            {(ibsStore.legalStyles.length != 0 && ibsStore.tempOptionsRowInfo.AssetCategoryName || !ibsStore.tempOptionsRowInfo.AssetCategoryName) &&
                                <div className="row">
                                    <div className="col-md-4">

                                        <span className="comment-heading">Mandate style:</span>  &nbsp;  <br />


                                    </div>
                                    <div className="col-md-4">
                                        <DropDownList className="wideInput surveySelect" data={ibsStore.legalStyles} value={ibsStore.tempOptionsRowInfo.MandateStyleName} onChange={onChangeMandateStyle} ></DropDownList>

                                    </div>

                                </div>
                            }
                            <div className="row">
                                <div className="col-md-4">

                                    <span className="comment-heading">Your identifier: </span>  &nbsp;  <br />


                                </div>
                                <div className="col-md-4">
                                    <input type="text" onChange={(e) => onChange('Ticker', e)} className="textInput def-textbox wideInput" onBlur={(e) => maxLengthCheck('Ticker', e, 12)} value={ibsStore.tempOptionsRowInfo.Ticker}></input>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">

                                    <span className="comment-heading">Share class: </span>  &nbsp;  <br />


                                </div>
                                <div className="col-md-4">
                                    <input type="text" onChange={(e) => onChange('ShareClass', e)} className="textInput def-textbox wideInput" onBlur={(e) => maxLengthCheck('ShareClass', e, 4)} value={ibsStore.tempOptionsRowInfo.ShareClass}></input>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <span className="comment-heading">Securities Lending: </span>  &nbsp;  <br />
                                </div>
                                <div className="col-md-4">
                                    <DropDownList className="wideInput surveySelect" data={["", "Yes", "No"]} onChange={onChangeUseSecLend} value={getUseSecLendValueForDropDown()}></DropDownList>
                                </div>
                            </div>
                            <br />
                            {ibsStore.editOptionModal &&
                                <button type="button" className="btn btn-close" onClick={saveAndCloseModal} disabled={allFieldsNotFilled()}>Save</button>
                            }
                            {!ibsStore.editOptionModal &&
                                <button type="button" className="btn btn-close" onClick={addAndCloseModal} disabled={allFieldsNotFilled()}> Add</button>
                            }
                            <button type="button" className="btn btn-close grey" onClick={closeModal}>Cancel</button>
                        </div>
                    </div>




                </Modal>
            </section>
        </React.Fragment>
    );

});

export default AddOptionRowModal;

// onClick={closeSurveyPreparerModal}
//<input type='checkbox' name="cb9" id="cb9" checked={store.surveyPreparerContent['tempRoles'].includes(PabsRoles.SUBMIT_USER)} onClick={() => onClickRole(PabsRoles.SUBMIT_USER)} /> <label htmlFor='cb9'>Submit</label>
                                //<input type="select" onChange={(e) => onChange('tempEmail', e)} className="textInput def-textbox" name={""} value={store.surveyPreparerContent['tempEmail']}></input>
